import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const EnAttenteValidation = () => {
  const navigate = useNavigate();
  const { user, accountStatus, logout, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (!user) {
    navigate('/accueil', { replace: true });
    return null;
  }

  const handleLogout = async () => {
    await logout();
    navigate('/accueil', { replace: true });
  };

  const refuse = accountStatus === 'refuse';

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-primary/3 flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center bg-white rounded-2xl shadow-sm border border-slate-100 p-8">
        <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6">
          <Clock className="w-8 h-8 text-primary" />
        </div>
        <h1 className="text-2xl font-bold text-slate-800 font-outfit mb-3">
          {refuse ? 'Compte non activé' : 'Compte en attente de validation'}
        </h1>
        <p className="text-slate-500 font-outfit mb-8">
          {refuse
            ? "Votre demande n'a pas pu être validée. Contactez-nous si vous pensez qu'il s'agit d'une erreur."
            : "Merci pour votre inscription. Nous vous contactons par email et par téléphone pour valider votre compte testeur avant de vous donner accès à Passerelle."}
        </p>
        <button
          onClick={handleLogout}
          className="w-full py-3.5 bg-primary text-white font-semibold rounded-2xl hover:bg-primary-dark transition-all duration-200 shadow-sm hover:shadow-md font-outfit"
        >
          Se déconnecter
        </button>
      </div>
    </div>
  );
};

export default EnAttenteValidation;
